'use strict';

const util = require('./modules/util');
const isBot = require('./modules/helpers/isBot').isBot;
const ritualsStyles = require('./rituals-styles');

exports.init = function init () {

    showLocaleSelectorDialogIfNeeded();

    const elements = {
        countryList:    $('.js-country_select'),
        languageList:   $('.js-language_select'),
        link:           $('.js-country-selector-link'),
        customSelect:   $('.js-country-selector .js-custom-select')
    };

    if (!elements.countryList.length || !elements.languageList.length || !elements.link.length) {
        return;
    }

    util.sortSelectOptions(elements.countryList);
    util.sortSelectOptions(elements.languageList);
    elements.customSelect.selectric();

    let countryListValue = elements.countryList.val();

    elements.countryList.on('change', function () {
        const currentCountry = elements.countryList.val();
        let positionOfPage = 0;
        positionOfPage = $(document).scrollTop();

        if (countryListValue === currentCountry) {
            positionOfPage = $(document).scrollTop();
            handleSelectricClose(positionOfPage, elements);

            return;
        }

        countryListValue = currentCountry;

        buildLocalesOptions(elements);
        updateFlags(elements);
        updateLink(elements);
        handleSelectricClose(positionOfPage, elements);
    });

    elements.languageList.on('change', function () {
        updateLink(elements);
    });
    buildLocalesOptions(elements);
    updateValues(elements);
    updateFlags(elements);
    updateLink(elements);
};

function handleSelectricClose (positionOfPage, elements) {
    elements.customSelect.off('selectric-close');
    elements.customSelect.on('selectric-close', function() {
        $('html, body').animate({
            scrollTop: positionOfPage
        }, 10);
    });
}

function buildLocalesOptions(elements){
    const locales = elements.countryList.find('option:selected').data('locales');
    const languageList = elements.languageList;

    $('option', languageList).remove();

    locales.forEach((locale) => {
        const option = $('<option>')
            .attr('url', locale.url)
            .attr('label', locale.label)
            .attr('flag', locale.flagImage)
            .attr('is-default', locale.isDefault)
            .val(locale.value)
            .text(locale.label);
        if (locale.isSelected) {
            option.attr('selected','selected');
        }

        languageList.append(option);
    });

    if (!languageList.find('option:selected')) {
        languageList.find('option[is-default=true]').attr('selected','selected');
    }

    util.sortSelectOptions(languageList);
    elements.customSelect.selectric();
}

function updateValues(elements) {
    const selectedCountry = elements.countryList.find('option:selected').val() || elements.countryList.val();
    const selectedLang = elements.languageList.find('option:selected').val() || elements.languageList.val();

    elements.countryList.val(selectedCountry);
    elements.languageList.val(selectedLang);
}

function updateLink(elements) {
    clearStorelocatorDropdown();

    const url = elements.languageList.find('option:selected').attr('url') || '';
    elements.link.attr('href', url);
}

function updateFlags(elements) {
    elements.countryList.css({
        backgroundImage: 'url("' + elements.countryList.find('option:selected').attr('flag') + '")'
    });
}

function clearStorelocatorDropdown() {
    if (typeof(Storage) !== 'undefined' && 'storeLocator' in localStorage) {
        delete localStorage.storeLocator;
    }
}

function showLocaleSelectorDialogIfNeeded() {
    if (navigator.cookieEnabled && !isBot) {
        openLocaleSelectorDialog();
    }
}

function checkIfEaster() {
    if ($('.world').length > 0 && $('.world').hasClass('js-3d-visible')) {
        $('body').addClass('no-scroll');
    }
}

function openLocaleSelectorDialog() {
    const $localePopup = $('#localePopupData');
    if (!$localePopup.length) {
        return;
    }

    const $pdInEditMode = $('#pdInEditMode');
    if ($pdInEditMode.length && $pdInEditMode.val() == true) {
        return;
    }

    const localePopupData = JSON.parse($localePopup.val());

    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: window.Resources.COUNTRY_SELECTOR_HEADING,
            headingLarge: true
        },
        paragraphs: [
            {
                text: window.Resources.COUNTRY_SELECTOR_DESCRIPTION
            }
        ],
        buttons: [
            {
                type: 'link link--large',
                label: localePopupData.linkResourceMessagePrimary,
                prependedBlock: '<span class="flag"><img src="' + localePopupData.flagImagePrimaryUrl + '" alt="" /></span>',
                eventName: 'onPrimaryButtonClick',
                shouldCloseModal: true
            },
            {
                type: 'link link--large',
                label: localePopupData.linkResourceMessageSecondary,
                prependedBlock: '<span class="flag"><img src="' + localePopupData.flagImageSecondaryUrl + '" alt="" /></span>',
                eventName: 'onSecondaryButtonClick',
                shouldCloseModal: false
            }
        ],
        row: {
            class: 'left-align'
        },
        closeElement: {
            eventName: 'onCloseElementClick',
            shouldCloseModal: true
        },
        ctaHolder: {},
        modalLarge: true
    });

    window.eventBus.$on('onPrimaryButtonClick', function() {
        setTimeout(function () {
            checkIfEaster();
            const jumpTo = util.getQueryStringParams(window.location.href).jumpto;
            ritualsStyles.jumpToAnchor(jumpTo);
        }, 100);

        if (localePopupData.redirectCurrentLocaleToHomepage) {
            window.location.href = window.Urls.home;
        }
    });

    window.eventBus.$on('onSecondaryButtonClick', function() {
        util.createCookie('ritualLocaleChanged', 1, 1);
        window.location.href = localePopupData.urlCookie;
    });

    window.eventBus.$on('onCloseElementClick', function() {
        setTimeout(function () {
            checkIfEaster();
            const jumpTo = util.getQueryStringParams(window.location.href).jumpto;
            ritualsStyles.jumpToAnchor(jumpTo);
        }, 100);
    });
}
